import type {Integer, Iso8601DateTime, Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {z as zod} from "zod";
import {integerZodValidator, iso8601DateTimeZodValidator, uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";

export type ProductInventory = {
    createdAt: Iso8601DateTime;
    createdBy: Uuid;
    id: Uuid;
    inventory: Integer;
    ouId: Uuid;
    productCatalogueId: Uuid;
    updatedAt: Iso8601DateTime;
    updatedBy: Uuid;
    workspaceId: Uuid;
};

export const productInventoryValidator: zod.ZodType<ProductInventory> = zod.object({
    createdAt: iso8601DateTimeZodValidator,
    createdBy: uuidZodValidator,
    id: uuidZodValidator,
    inventory: integerZodValidator,
    ouId: uuidZodValidator,
    productCatalogueId: uuidZodValidator,
    updatedAt: iso8601DateTimeZodValidator,
    updatedBy: uuidZodValidator,
    workspaceId: uuidZodValidator,
});
